/**
 * The QR codes printed/scanned in the field are not case-consistent
 * (id / Id / ID etc.), so we probe every casing the original app supported.
 */
function readAnyCase(params, key) {
  const upper = key.toUpperCase();
  const lower = key.toLowerCase();
  const title = key[0].toUpperCase() + key.slice(1).toLowerCase();

  return params.get(lower) ?? params.get(title) ?? params.get(upper);
}

export function parseQrParams(search) {
  const params = new URLSearchParams(search);

  return {
    id: readAnyCase(params, "id"),
    lid: readAnyCase(params, "lid"),
    bid: readAnyCase(params, "bid"),
  };
}

export function buildQrQueryString({ id, lid, bid }) {
  const params = new URLSearchParams();
  if (id != null) params.set("id", id);
  if (lid != null) params.set("lid", lid);
  if (bid != null) params.set("bid", bid);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}
